// extracted by mini-css-extract-plugin
export default {"darkBackground":"PopupBackground_darkBackground__iDz9m"};